export default "__VITE_ASSET__v31UpNDM__"